 $(document).ready(function() {
   var regularPrice = $('.block-price__regular.product__price span[aria-hidden="true"]').text().trim();
regularPrice = parseFloat(regularPrice.replace(/[$,]/g, ''));


function formatNumberWithIndianCommas(number) {
    var x = number.toString().split('.');
    var lastThree = x[0].substring(x[0].length - 3);
    var otherNumbers = x[0].substring(0, x[0].length - 3);
    if (otherNumbers != '') {
        lastThree = ',' + lastThree;
    }
    var result = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
    return x.length > 1 ? result + '.' + x[1] : result;
}


   updateTotalPrice();


function updateTotalPrice(qty) {
  

    // if (typeof qty === 'undefined') {
    //     console.error("qty is undefined, please check how the function is called.");
    //     return;
    // }
  
    if (isNaN(qty) || qty < 1) {
        qty = 1; // Ensure qty is at least 1
    }

    var totalPrice = (regularPrice * qty) / 100;
 //console.log((totalPrice.toLocaleString().toFixed(2));
    $('.total-price-value').text('$' + totalPrice.toLocaleString()+'.00');
  
}

            //var boxSqft = parseFloat($('#product-metafield').data('box-sqft'));
            //var boxPieces = parseFloat($('#product-pieces-metafield').data('box-pieces'));
            var boxSqft = parseFloat($('#boz-sqft-p').data('box-sqft'));
            var boxPieces = parseFloat($('#product-pieces-metafield_new').data('box-pieces')); 

            var $input = $('#project-size');
            var $display = $('#size-display');
            var $quantityInput = $('.js-qty__num');

          var $checkbox = $('#contingency-checkbox');

           var calculateBoxes = function(projectSize) {
    if (!isNaN(projectSize) && projectSize > 0) {
        var numberOfBoxes = Math.ceil(projectSize / boxSqft);
        var numberOfPieces = Math.ceil(numberOfBoxes * boxPieces);

        if ($checkbox.is(':checked')) {
          var adjustednumberOfBoxes = Math.ceil((projectSize*1.1) / boxSqft);
          numberOfBoxes = adjustednumberOfBoxes;
        var  adjustednumberOfPieces = Math.ceil(adjustednumberOfBoxes * boxPieces);
            /// numberOfPieces = Math.ceil(numberOfPieces * 1.1);
          numberOfPieces = adjustednumberOfPieces;
            console.log("numberOfPieces after adjustment:", numberOfPieces);
            console.log("Before calling updateTotalPrice, numberOfPieces:", numberOfPieces);
            updateTotalPrice(numberOfPieces); // Pass numberOfPieces as the argument
        } else {
            console.log("numberOfPieces without adjustment:", numberOfPieces);
          updateTotalPrice(numberOfPieces);
        }

        if (!isNaN(numberOfPieces)) {
            $display.text(numberOfPieces + ' Piece' + (numberOfPieces > 1 ? 's Estimated' : ''));
        } else {
            $display.text(numberOfBoxes + ' Box' + (numberOfBoxes > 1 ? 'es' : ''));
        }
        $quantityInput.val(numberOfPieces);
    } else {
        $display.text('');
        $quantityInput.val(1);
    }
};

         
            $input.on('input', function() {
                var projectSize = Math.ceil($(this).val());
             // console.log('project size'+ projectSize);
                 var numberOfBoxes = Math.ceil(projectSize / boxSqft);
             // console.log('bx sqft'+ boxSqft);
             // console.log('numberOfBoxes'+ numberOfBoxes);
                  var numberOfPieces = numberOfBoxes * boxPieces;
             // console.log('numberOfPieces'+ numberOfPieces);
              
             calculateBoxes(projectSize);
             updateTotalPrice(numberOfPieces);
            });

      
      $checkbox.on('change', function() {
                var projectSize = Math.floor($input.val());
                calculateBoxes(projectSize);
        
         updateTotalPrice();
            });

   $('.js-qty__num').on('input', function() {
        updateTotalPrice();
    });


$('.js-qty__adjust--plus').off('click').on('click', function () {
    let $input = $(this).siblings('.js-qty__num');
     let currentQty = parseInt($input.val()) || 1;
     console.log("Button clicked",currentQty);
    $display.text(currentQty + ' Piece' + (currentQty > 1 ? 's' : ''));
     updateTotalPrice(currentQty);
 });

$('.js-qty__adjust--minus').on('click', function () {
   let $input = $(this).siblings('.js-qty__num');
     let currentQty = parseInt($input.val()) || 1;
    
    $display.text(currentQty + ' Piece' + (currentQty > 1 ? 's' : ''));
     updateTotalPrice(currentQty);
});


   
  const $scrollUp = $('#scroll-up');
  $(window).scroll(function () {
    if ($(this).scrollTop() > 200) {
      $scrollUp.fadeIn();
    } else {
      $scrollUp.fadeOut();
    }
  });

 
  $scrollUp.on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  });


$('#tileForm').on('submit' , function(e) {
 e.preventDefault();


      const roomLength = parseFloat($('#roomLength').val());
  console.log("roomLength",roomLength);
      const roomWidth = parseFloat($('#roomWidth').val());
   console.log("roomWidth",roomWidth);
      const tileSize = $('#size').val().trim();
  console.log("tileSize",tileSize);
      const wastage = parseFloat($('#wastage').val());

  console.log("wastage",wastage);
  
      const $resultEl = $('#result');
      const $errorEl = $('#error-msg');


    // Validate tile size (e.g., 12x24 or 24 x 12)
      const match = tileSize.match(/^(\d+)\s*[xX]\s*(\d+)$/);
      if (!match) {
        $errorEl.show();
        $resultEl.html('');
        return;
      } else {
        $errorEl.hide();
      }
  
    const tileLengthIn = parseFloat(match[1]);
      const tileWidthIn = parseFloat(match[2]);
  
    console.log("tileLengthIn",tileLengthIn);
  console.log("tileWidthIn",tileWidthIn);

   const roomAreaSqIn = (roomLength * 12) * (roomWidth * 12);
      const tileAreaSqIn = tileLengthIn * tileWidthIn;

      console.log("roomAreaSqIn",roomAreaSqIn);
  console.log("tileAreaSqIn",tileAreaSqIn);

     const tilesNeeded = Math.ceil(roomAreaSqIn / tileAreaSqIn);
      const totalWithWastage = Math.ceil(tilesNeeded * (1 + wastage / 100));

       console.log("tilesNeeded",tilesNeeded);
  console.log("totalWithWastage",totalWithWastage);

   $resultEl.html(`You need <strong>${totalWithWastage}</strong> tiles including ${wastage}% wastage.`);
  
})




   

        });







// $('#size').on('input', function () {
// const value = $(this).val();
    
   
//     const validPattern = /^(\d{1,4})?[xX]?(\d{1,4})?$/;

//     if (validPattern.test(value)) {
//       $('#error-msg').hide();
//     } else {
//       $('#error-msg').show();
//     }

   
//     const xCount = (value.match(/[xX]/g) || []).length;
//     if (xCount > 1) {
//       $(this).val(value.replace(/[^0-9xX]/g, '').replace(/([xX])(.*)([xX])/g, '$1$2')); // Keep only first x
//     }

// });
